// extracted by mini-css-extract-plugin
export default {"content":"Card_content__rmV9U","fav":"Card_fav__ix7R2","boton":"Card_boton__+XmKs"};